module.exports = __webpack_public_path__ + "static/profile-pic-6fa4d097b45cac5c3caaeb7c6637c7b4.jpg";